export function isEmpty(obj: any): obj is undefined | null {
  return typeof obj === "undefined" || obj === null || obj === "";
}

export function getQueryVariable(variable: string) {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}

export function getVersionFromUrl(): string {
  return getQueryVariable("ver") || "";
}

/** 合并 className（供 shadcn 风格组件使用） */
export function cn(...inputs: Array<string | false | null | undefined>) {
  return inputs.filter(Boolean).join(" ");
}
